import type { Activity } from "@amazing-care/types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { dataSource } from "@/lib/data-source";
import { queryKeys } from "@/lib/query-keys";

export function useActivities() {
  return useQuery({
    queryKey: queryKeys.activities,
    queryFn: () => dataSource.listActivities(),
  });
}

export function useActivity(activityId: string, { enabled = true } = {}) {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: queryKeys.activity(activityId),
    queryFn: () => dataSource.getActivity(activityId),
    enabled,
    // Opened from the home feed or the admin list, which already hold it.
    placeholderData: () =>
      queryClient
        .getQueryData<Activity[]>(queryKeys.activities)
        ?.find((activity) => activity.id === activityId),
  });
}
